import { ColumnsType } from 'antd/es/table';

export const headerCabinet: ColumnsType<any> = [
  {
    title: 'Mã cửa hàng',
    dataIndex: 'code',
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'name',
  },
  {
    title: 'Mã tủ',
    dataIndex: 'cabinet_code',
  },
  {
    title: 'Mô tả',
    dataIndex: 'description',
  },
  {
    title: 'Số lượng',
    dataIndex: 'total_cabinet',
  },
  {
    title: 'Đăng ký tối thiểu',
    dataIndex: 'min_register',
  },
  {
    title: 'Đăng ký tối đa',
    dataIndex: 'max_register',
  },
  {
    title: 'Tỷ trọng vốn max kế hoạch',
    dataIndex: 'ratio_max',
  },
  {
    title: 'Vốn max kế hoạch',
    dataIndex: 'max_plan',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
  },
];
